/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of template for a notification
 * @export
 */
export const NotificationTemplateTypeEnum = {
    AppointmentPending: 'APPOINTMENT_PENDING',
    AppointmentConfirmed: 'APPOINTMENT_CONFIRMED',
    AppointmentCancelled: 'APPOINTMENT_CANCELLED',
    AppointmentUpdated: 'APPOINTMENT_UPDATED',
    AppointmentReminder: 'APPOINTMENT_REMINDER',
    Error: 'ERROR',
    Taskbox: 'TASKBOX'
} as const;
export type NotificationTemplateTypeEnum = typeof NotificationTemplateTypeEnum[keyof typeof NotificationTemplateTypeEnum];


export function instanceOfNotificationTemplateTypeEnum(value: any): boolean {
    for (const key in NotificationTemplateTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(NotificationTemplateTypeEnum, key)) {
            if (NotificationTemplateTypeEnum[key as keyof typeof NotificationTemplateTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NotificationTemplateTypeEnumFromJSON(json: any): NotificationTemplateTypeEnum {
    return NotificationTemplateTypeEnumFromJSONTyped(json, false);
}

export function NotificationTemplateTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationTemplateTypeEnum {
    return json as NotificationTemplateTypeEnum;
}

export function NotificationTemplateTypeEnumToJSON(value?: NotificationTemplateTypeEnum | null): any {
    return value as any;
}

export function NotificationTemplateTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): NotificationTemplateTypeEnum {
    return value as NotificationTemplateTypeEnum;
}

